<template>
  <!-- 底部导航 -->
  <div class="footerNav">
    <div class="pc">
      <div class="footer-main pc">
        <div class="content">
          <div class="footerBg">
            <img :src="footerBg" style="width: 100%; height: 100%" alt="" />
          </div>
          <div style="display: flex; align-items: center; margin: 0 auto">
            <div class="content-left">
              <div class="logo">
                <div>
                  <img :src="logo" style="height: 93px" alt="" />
                </div>
                <div style="margin-left: 27px; flex: 1">
                  <div
                    style="
                      font-size: 38px;
                      font-weight: bold;
                      color: #000000;
                      line-height: 38px;
                      margin-bottom: 9px;
                    "
                  >
                    御方汇
                  </div>
                  <div
                    style="
                      font-size: 18px;
                      font-weight: normal;
                      color: #000000;
                      line-height: 22px;
                    "
                  >
                    <span>黄家圣幸实业集团旗下原料品牌</span>
                  </div>
                </div>
              </div>
              <div class="qrCode">
                <div style="margin-right: 47px">
                  <div>
                    <img :src="qrcode" alt="" />
                  </div>
                  <div class="imgName">官方公众号</div>
                </div>
                <div>
                  <div>
                    <img :src="customerQrcode" alt="" />
                  </div>
                  <div class="imgName">官方客服</div>
                </div>
              </div>
            </div>
            <div class="line"></div>
            <div class="content-right" style="">
              <div class="display-flex" style="letter-spacing: 0px">
                <div
                  v-for="(item, index) of menuList"
                  :key="index"
                  :style="
                    index !== menuList.length - 1 ? 'margin-right:100px;' : ''
                  "
                  class="urlBtn"
                >
                  <div
                    class="title"
                    style="margin-bottom: 35px; font-size: 26px; font-weight: 400"
                  >
                    {{ item.menuName }}
                  </div>
                  <div
                    style="
                      font-size: 18px;
                      margin-bottom: 26px;
                      line-height: 17px;
                    "
                    @click="goUrl(items.component, items.url)"
                    v-for="(items, indexs) of item.children"
                    :key="indexs"
                  >
                    <span>{{ items.menuName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            background: #719468;
            padding: 10px 0;
            text-align: center;
            color: #fff;
          "
        >
          <span style="font-size: 15px"
            >COPY © 2022 广州黄家圣幸生物科技有限公司 ALL RIGHTS RESERVED.</span
          >
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            style="font-size: 15px; margin-left: 20px; color: #fff"
            >{{ keeponnumber }}</a
          >
          <p
            style="
              font-size: 15px;
              margin-left: 20px;
              color: #fff;
              text-align: center;
              margin-top: 5px;
            "
          >
            联系热线：{{ phone }} | <a target="_blank" href="./sitemap.xml" style="color:#fff;">网站地图</a>
          </p>
        </div>
      </div>
    </div>
    <div class="mobile" style="position:absolute;z-index:100;width:100%;bottom:0;">
      <div >
        <div class="footerBg">
          <img :src="footerBg" style="width: 100%; height: 100%" alt="" />
        </div>
        <div style="display: flex; align-items: center; padding: 0.3rem 0.2rem">
          <div style="flex:1;">
            <div style="display: flex; align-items: center">
              <div style="width: 0.38rem; margin-right: 0.13rem">
                <img src="@/assets/logo.png" style="width: 100%" alt="" />
              </div>
              <div>
                <div
                  style="
                    font-size: 0.2rem;
                    font-weight: bold;
                    margin-bottom: 0.03rem;
                    color: #000000;
                  "
                >
                  御方汇
                </div>
                <div style="font-size: 0.13rem; color: #000000">
                  黄家圣幸实业集团旗下原料品牌
                </div>
              </div>
            </div>
            <div style="display: flex; align-items: center;margin-top:0.13rem;">
              <img src="@/assets/phone.png" style="width: 0.14rem; margin-right: 0.06rem" alt="" />
              <div>
                <div
                  style="
                    font-size: 0.14rem;
                font-weight: bold;
                    color: #000000;
                  "
                >
                  {{phone}}
                </div>
              </div>
            </div>
            <div style="font-size:0.11rem;margin-top:0.06rem;">
              {{address}}
            </div>
          </div>
          <div style="text-align:center;">
            <div style="width: 0.56rem;margin:0 auto 0.1rem;">
              <img :src="qrcode" alt="" style="width: 100%" />
            </div>
            <div style="font-size:0.12rem;">官方公众号</div>
          </div>
        </div>
      </div>
      <div style="text-align:center;font-size:0.1rem;color:#959595;padding-bottom:0.14rem;">
          <div style="margin-bottom:0.05rem;">
            COPY © 2022 广州黄家圣幸生物科技有限公司 ALL RIGHTS RESERVED.
          </div>
          <div>
           <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            style="color:#959595;"
            >{{ keeponnumber }}</a
          >
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { menuList, getConfByKey } from '@/api/common'
export default {
  name: 'footerNav',
  data() {
    return {
      menuList: [],
      logo: '',
      qrcode: '',
      customerQrcode: '',
      footerBg: '',
      keeponnumber: '',
      phone: '',
      address:''
    }
  },
  mounted() {
    menuList({ typeOf: 2 }).then((res) => {
      this.menuList = res.data
    })
    this.getInfo()
  },
  methods: {
    getInfo() {
      // 获取手机号
      this.phone = this.getBaseInfo().phone
      // 获取logo
      this.logo = this.getUrlPrefix(this.getBaseInfo().logo)
      // 获取公众号
      this.qrcode = this.getUrlPrefix(this.getBaseInfo().qrcode)
      // 获取客服
      this.customerQrcode = this.getUrlPrefix(this.getBaseInfo().customerQrcode)
      // 获取地址
      var address = this.getBaseInfo().address
      address = address.replace("；",";")
      if(address.indexOf(';') !== -1){
        this.address = address.split(";")[0]
        var indexs = this.address.indexOf('地址:')
        var newAddress = this.address.slice(indexs,this.address.length)
        this.address = newAddress
      }else{
        this.address = address
      }
      
      // 获取底部背景图
      this.footerBg = this.getUrlPrefix(this.getBaseInfo().footerBg)

      // 获取备案号
      this.keeponnumber = this.getBaseInfo().keeponnumber
    },
    goUrl(component, url) {
      var path = ''
      if (url.indexOf('#') !== -1) {
        path = `/${component}${url}`
      } else {
        path = `/${component}`
      }
      this.$router.push({ path })
    },
  },
}
</script>

<style lang="scss">
.footerNav {
  width: 100%;
  .pc{
    position:relative;
    .footer-main {
    .content {
      position: relative;
      padding: 65px 0;
      display: flex;
      align-items: center;
      .content-left {
      }
      .line {
        width: 1px;
        background: #719468;
        height: 300px;
        margin: 2px 43px 2px 50px;
      }
      .content-right {
        flex: 1;
      }
    }
    .logo {
      display: flex;
      align-items: center;
    }
    .qrCode {
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      margin-top: 47px;
      img {
        width: 120px;
        margin-bottom: 18px;
      }
      .imgName {
        font-size: 21px;
      }
    }
    .footerBg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.8;
      z-index: -1;
    }
    .urlBtn {
      span:hover {
        color: #719468;
        cursor: pointer;
      }
    }
  }
  }
  
  .mobile {

    .footerBg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.8;
      z-index: -1;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footerNav/index.vue